import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Observable } from 'rxjs/Observable'
import { DadosRelatorio } from './dados-relatorio'
import { DadosRelatorioService } from './dados-relatorio.service'
import { OpcoesRelatorio } from './opcoes-relatorio.interface'
import { RelatorioService } from './relatorio.service'

@Component({
    selector: 'col-relatorio',
    templateUrl: './relatorio.component.html',
    styleUrls: ['./relatorio.component.scss']
})
export class RelatorioComponent implements OnInit {
    opcoes: OpcoesRelatorio
    dados: DadosRelatorio

    constructor(
        private route: ActivatedRoute,
        private dadosRelatorioService: DadosRelatorioService,
        private relatorioService: RelatorioService
    ) {}

    ngOnInit() {
        this.route.data.subscribe((data: { opcoesRelatorio: OpcoesRelatorio }) => {
            this.opcoes = data.opcoesRelatorio
            this.obterDados().subscribe(dados => {
                this.dados = dados
            })
        })
    }

    imprimir() {
        window.print()
    }

    private obterDados() {
        if (this.dadosRelatorioService.possui()) {
            const dados = this.dadosRelatorioService.obter()

            this.dadosRelatorioService.limpar()

            return Observable.of(dados)
        }

        return this.relatorioService.gerarDados(this.opcoes)
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/relatorio/relatorio.component.ts